import { useMember , useBasePath} from 'components/Providers'
import { useSelector, useDispatch } from 'react-redux'
import { useEffect, useState } from 'react'
import * as action from 'store/member/final-grades'
import FinalGrades from 'components/FinalGrades'
import NotFound from 'components/NotFound'
import Skeleton from './Skeleton'
// import { Box, Button } from '@mui/material'

// TODO: sort course session by name

export default function Index() {
  const member = useMember()
  const dispatch = useDispatch()
  const basePath = useBasePath()

  const [notFound, setNotFound] = useState(false)

  const courseSessionEnrollmentGrades = useSelector(state => state.member.list?.find(item => item.id === member.id))
    .finalGrades?.data

  const gpas = useSelector(state => state.member.list?.find(item => item.id === member.id)).finalGrades?.gpas

  const markingPeriods = useSelector(state => state.session.academicYear.markingPeriods)

  const permission = useSelector(state => state.session.permissions)
  const hasCourseSessionViewPermission = parseInt(permission['setting.course-session'])

  useEffect(() => {
    dispatch(action.retrieve({ type: member.person?.type, memberId: member.id })).then(res => {
      res.error && setNotFound(true)
    })
  }, [dispatch, member.id, member.person?.type])

  if (notFound) return <NotFound basePath={`${basePath}/final-grades`} />

  if (!(courseSessionEnrollmentGrades && markingPeriods)) {
    return <Skeleton />
  }

  return (
    <>
    {/* <Box variant="h5" sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
      <Button variant="contained" color="primary" size='small'>
        Sync Schoology Grades
      </Button>
    </Box> */}
    <FinalGrades
      courseSessionEnrollmentGrades={courseSessionEnrollmentGrades}
      markingPeriods={markingPeriods}
      hasCourseSessionViewPermission={hasCourseSessionViewPermission}
      gpas={gpas}
    />
    </>
  )
}
